import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import UsuarioContext from "../../../../context/userContext/context";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';

import ReactInputMask from "react-input-mask";
import Avatar from "react-avatar";
import Error from "../../../components/Error";
import { toast } from "react-toastify";
import { Container, Row, Col, Form, OverlayTrigger, Tooltip, Button, Spinner, Badge } from "react-bootstrap";
import { ContentBody, ContentHeader } from "./styled";
import { Modal } from "../../../components/modal";

//utils
import { MdClose, MdOutlineEdit, MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md";
import { colors } from "../../../../theme/theme";
import { IUserAccount } from "../../../models/IUserAccount";

//services
import { addCompanyToUser, mailChange, passwordChange, profileDetails, saveCompanyAddress, saveCompanyDetails, saveProfileDetails } from "../../../services/profile.service";
import { formatCnpj } from "../../../../helpers";

const validationSchema = Yup.object({
    name: Yup.string().trim().required("Este campo é obrigatório"),
    username: Yup.string().trim().required("Este campo é obrigatório"),
    phone: Yup.string().required("Este campo é obrigatório"),
    socialReason: Yup.string().trim().required("Este campo é obrigatório"),
    fantasyName: Yup.string().trim().required("Este campo é obrigatório"),
    cnpj: Yup.string().trim().required("Este campo é obrigatório"),
    cep: Yup.string().trim().required("Este campo é obrigatório"),
    address: Yup.string().trim().required("Este campo é obrigatório"),
    number: Yup.string().trim().required("Este campo é obrigatório"),
    district: Yup.string().trim().required("Este campo é obrigatório"),
    city: Yup.string().trim().required("Este campo é obrigatório"),
    state: Yup.string().trim().required("Este campo é obrigatório"),
}).required();

const validationSchemaMail = Yup.object({
    email: Yup.string().email('E-mail inválido').required("Este campo é obrigatório"),
    confirmEmail: Yup.string().email('E-mail inválido').required("Este campo é obrigatório").oneOf([Yup.ref('email')], 'Os e-mails digitados são diferentes.'),
}).required();

const validationSchemaPassword = Yup.object({
    currentPassword: Yup.string().required("Este campo é obrigatório"),
    newPassword: Yup.string().required("Este campo é obrigatório"),
    confirmPassword: Yup.string().required("Este campo é obrigatório").oneOf([Yup.ref('newPassword')], 'As senhas digitadas são diferentes.'),
}).required();

const DEFAULT_VALUE = {
    id: 0,
    name: "",
    company: "",
    job: "",
    phone: "",
    email: "",
    picture: "",
    signature: "",
    username: "",
    created_at: "",
    deleted_at: "",
    updated_at: "",
    is_superuser: false,
    is_staff: false,
    is_active: false,
    is_whatsapp: false,
    is_signature: false,
  }

  export const Profile = (): JSX.Element => {
    const { t: translation } = useTranslation();
    const { user: userContext, update } = useContext(UsuarioContext)
    const { register, handleSubmit, control, formState: { errors } } = useForm({ resolver: yupResolver(validationSchema) });
    const { register: registerMail, handleSubmit: handleSubmitMail, formState: { errors: errorsMail } } = useForm({ resolver: yupResolver(validationSchemaMail) });
    const { register: registerPassword, handleSubmit: handleSubmitPassword, setValue, formState: { errors: errorsPassword } } = useForm({ resolver: yupResolver(validationSchemaPassword) });
    
    const [user, setUser] = useState<IUserAccount>(DEFAULT_VALUE);  
    const [company, setCompany] = useState(user.company);  
    const [loading, setLoading] = useState(true);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [loadingModal, setLoadingModal] = useState<boolean>(false);

    const [updatePhoto, setUpdatePhoto] = useState(false);
    const [removePhotoUser, setRemovePhotoUser] = useState(false);
    const [originalPreviewPhoto, setOriginalPreviewPhoto] = useState(null);
    const [previewPhoto, setPreviewPhoto] = useState("");

    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState<boolean>(false);
    const [updateEmail, setUpdateEmail] = useState<boolean>(false);
    const [emailChanged, setEmailChanged] = useState("");
    const [updateEmailPending, setUpdateEmailPending] = useState<boolean>(false);
    const [updatePassword, setUpdatePassword] = useState<boolean>(false);

    const handleChangePhoto = (img: any) => {
        setOriginalPreviewPhoto(img);
        setPreviewPhoto(URL.createObjectURL(img));
        setRemovePhotoUser(true);
    }

    const onSubmit = (params: any) => {
        setLoadingSubmit(true)

        let objCompanyAddress = {
            public_space: params.address,
            cep: parseInt(params.cep.replace("-","")),
            number: params.number,
            district: params.district,
            city: params.city,
            state: params.state
        }

        if (removePhotoUser) {
            params['picture'] = "";
        } else if (originalPreviewPhoto === null) {
            params['picture'] = userContext.picture;
        } else {
            params['picture'] = originalPreviewPhoto
        }

        params['is_whatsapp'] = user.is_whatsapp;

        saveProfileDetails(user.id, params).then((response: any) => {
            setUser(response);
            update({ ...userContext, picture: response.picture, name: response.name, phone: response.phone, username: response.username});
            setOriginalPreviewPhoto(null);
            setPreviewPhoto("");

            if (company && company.address && Object.keys(company.address).length !== 0) {
                let objCompany = {
                    cnpj: params.cnpj,
                    fantasy: params.fantasyName,
                    name: params.socialReason,
                }            
    
                saveCompanyDetails(objCompany, company.id).then(() => {
                    saveCompanyAddress(objCompanyAddress, company.address.id).then(() => {
                        toast.success("Dados da conta alterados com sucesso!");
                        setLoadingSubmit(false)
                    }).catch((err: any) => {
                        toast.error('Ocorreu um erro ao editar os dados da empresa');
                        setLoadingSubmit(false)
                    })
                }).catch((err) => {
                    setLoadingSubmit(false)
                    toast.error(err.response.data[0]);
                })
    
            } else if (company && company.address && Object.keys(company.address).length === 0) {
                saveCompanyAddress(objCompanyAddress).then((_response) => {
                    let objUpdateAddressCompany = {
                        cnpj: params.cnpj,
                        fantasy: params.fantasyName,
                        name: params.socialReason,
                        address: _response.id
                    }
    
                    saveCompanyDetails(objUpdateAddressCompany, company.id).then(() => {
                        toast.success("Dados da conta alterados com sucesso!");
                        setLoadingSubmit(false)
                    }).catch((err) => {
                        setLoadingSubmit(false)
                        toast.error(err.response.data[0]);
                    })
                })
    
            } else {
                saveCompanyAddress(objCompanyAddress).then((_response) => {
                    let objNewCompany = {
                        cnpj: params.cnpj,
                        fantasy: params.fantasyName,
                        name: params.socialReason,
                        address: _response.id
                    }
    
                    saveCompanyDetails(objNewCompany).then((res) => {
                        let userCompany = {
                            id: user.id,
                            name: user.name,
                            company: res.id,
                            phone: user.phone,
                            email: user.email,
                        }
                        
                        addCompanyToUser(user.id, userCompany).then(() =>{
                            toast.success("Dados da conta alterados com sucesso!");
                            setLoadingSubmit(false)
                        }).catch((err) => {
                            toast.error('Ocorreu um erro ao editar os dados da empresa');
                            setLoadingSubmit(false)
                        })
                    }).catch((err) => {
                        toast.error(err.response.data[0]);
                        setLoadingSubmit(false)
                    })
                }).catch((err) => {
                    toast.error(err.response.data[0]);
                    setLoadingSubmit(false)
                })
            }

            getUser();
            setUpdatePhoto(false)
        }).catch((err: any) => {
            console.log(err);
            toast.error(err.response.data);
            setLoadingSubmit(false)
        })
    }

    const onSubmitEmailUpdate = (formEmail: any) => {
        setLoadingModal(true)
        let obj = {
            email_old: user.email,
            email_new1: formEmail.email,
            email_new2: formEmail.confirmEmail,
        }

        mailChange(obj).then(() => {
            setEmailChanged(formEmail.email)
            update({ ...userContext, email: formEmail.email});
            setUpdateEmailPending(true);
            setUpdateEmail(false);
            setLoadingModal(false)
            toast.success(`Um e-mail de confirmação foi enviado ao endereço ${formEmail.email}. Se o novo endereço não for confirmado no prazo de 3 dias a alteração será descartada.`)
        }).catch((err) => {
            setLoadingModal(false)
            toast.error(err.response.data[0]);
        })
    }

    const onSubmitPassword = (formPassword: any) => {
        setLoadingModal(true)
        let obj = {
            password_old: formPassword.currentPassword,
            password_new1: formPassword.newPassword,
            password_new2: formPassword.confirmPassword,
        }

        passwordChange(obj).then(() => {
            setLoadingModal(false)
            toast.success('Senha alterada com sucesso!')
            setUpdatePassword(false);
            setValue('currentPassword', "")
            setValue('newPassword', "")
            setValue('confirmPassword', "")
        }).catch((err) => {
            setLoadingModal(false)
            toast.error(err.response.data[0]);
        })
    }

    const getUser = () => {
        profileDetails(userContext.id).then((response: any) => {
            setUser(response)
            setCompany(response.company)
        }).finally(() => {
          setLoading(false);
        })
      }

    useEffect(() => {
        getUser();
    }, [])

    useEffect(() => {
        if(previewPhoto !== "" && removePhotoUser) {
            setRemovePhotoUser(false);
        }
    },[previewPhoto])

    if (loading) {
        return (
          <div className="loading-container mt-5">
            <Spinner animation="border" variant="primary" />
          </div>
        )
      }

    return (  
        <Container fluid>
            <ContentHeader>
                <Row>
                    <div className="title">Perfil</div>
                </Row>
            </ContentHeader>
            <ContentBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md={12} xl={6}>
                            <Col md={11} xxl={10}>
                                <h5 className="mt-3"><b>{translation('userAccount.account')}</b></h5>
                                <Form.Group className="mt-2 mb-2">
                                    <Form.Label className="text-darker-grey">{translation('userAccount.displayName')}:</Form.Label><br />
                                    <Form.Control type="text" placeholder="Responsável" defaultValue={ user.name } {...register("name", { required: true })} />
                                    {errors.name ? (<div className="w-100"> <Error>{errors.name?.message}</Error> </div>) : ""}
                                </Form.Group>

                                <Controller
                                    name="phone"
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue={ user.phone }
                                    render={({ field }) => (
                                        <ReactInputMask mask="(99) 99999-9999"
                                            value={field.value}
                                            onChange={field.onChange}
                                        >
                                            {(inputProps: any) => (
                                                <Form.Group className="mb-2">
                                                    <Form.Label className="text-darker-grey">{translation('userAccount.phone')}:</Form.Label><br />
                                                    <Form.Control type="text" {...inputProps} />
                                                    {errors.phone ? (<div className="w-100"> <Error>{errors.phone?.message}</Error> </div>) : ""}
                                                </Form.Group>
                                            )}
                                        </ReactInputMask>
                                    )}
                                />

                                <Form.Group className="mb-4">
                                    <Form.Label className="text-darker-grey">{translation('userAccount.responsible')}:</Form.Label>
                                    <Form.Control type="text" placeholder="Nome de exibição" defaultValue={user.username} {...register("username", { required: true })} />
                                    {errors.username ? (<div className="w-100"> <Error>{errors.username?.message}</Error> </div>) : ""}
                                </Form.Group>

                                
                                <Row className={updatePhoto ? 'photo-edit-group-manager' : ''}>
                                    {
                                        updatePhoto && 
                                        <div>
                                            <Form.Group className="">
                                                <OverlayTrigger
                                                    placement={'top'}
                                                    overlay={<Tooltip id="edit-photo">{user.picture ? (removePhotoUser ? translation('manager.addPhoto') : translation('manager.editPhoto')) : translation('manager.addPhoto')}</Tooltip>}
                                                >
                                                    <Form.Label htmlFor="photo_edit" className="text-darker-grey"><MdOutlineEdit/></Form.Label>
                                                </OverlayTrigger>
                                                <Form.Control className="d-none" type="file" id="photo_edit" onChange={(e: any) => handleChangePhoto(e.target.files[0])}/>
                                            </Form.Group>
                                            
                                            <OverlayTrigger
                                                placement={'top'}
                                                overlay={<Tooltip id="remove-photo">{translation('manager.removePhoto')}</Tooltip>}
                                            >
                                                <Form.Label htmlFor="photo_remove" className="text-darker-grey label-remove" onClick={() => {
                                                    setRemovePhotoUser(true);
                                                    setOriginalPreviewPhoto(null);
                                                    setPreviewPhoto("");
                                                } }>
                                                    <MdClose/>
                                                </Form.Label>
                                            </OverlayTrigger>
                                        </div>
                                    }
                                    <Col md={5} xl={4} xxl={3}>
                                        <Avatar size="150" round={false} name={userContext.username !== "" ? userContext.username : "U S"}
                                            src={
                                                !removePhotoUser ? (
                                                    previewPhoto !== "" ? previewPhoto : (userContext.picture ?? "U S")
                                                ) : "U S"
                                            } color={colors.mainColors.blueberry} 
                                        />
                                    </Col>
                                    <Col className="d-flex align-items-end">
                                        <Button variant="link" style={{ textDecoration: 'none' }} onClick={() => setUpdatePhoto(!updatePhoto)}>
                                            {updatePhoto ? translation('cancel') : translation('manager.editPhoto')} 
                                        </Button>
                                    </Col>
                                </Row>

                                <h5 className="mt-5"><b>{translation('userAccount.access')}</b></h5>
                                <Col xs={12} className="mb-2">
                                    <Row>
                                        <Col sm={6}>
                                            <h6>
                                                <span className="text-darker-grey">{translation('userAccount.email')}: </span>
                                                {user.email}
                                                {
                                                    updateEmailPending && (
                                                        <OverlayTrigger placement={'top'} overlay={<Tooltip>Um e-mail de confirmação foi enviado ao endereço {emailChanged}. Se o novo endereço não for confirmado no prazo de 3 dias a alteração será descartada.</Tooltip>}>
                                                            <Badge className="badge-mail-pending">{translation('userAccount.pendingMail')}</Badge>
                                                        </OverlayTrigger>
                                                    )
                                                }
                                            </h6>
                                        </Col>
                                        <Col sm={6} className="d-flex justify-content-end">
                                            <Button variant="link" style={{ textDecoration: 'none' }} onClick={() => setUpdateEmail(true)}>{translation('userAccount.updateEmail')}</Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} className="mb-2">
                                    <Row>
                                        <Col sm={6}>
                                            <h6><span className="text-darker-grey">{translation('userAccount.password')}:</span> ********</h6>
                                        </Col>
                                        <Col sm={6} className="d-flex justify-content-end">
                                            <Button variant="link" style={{ textDecoration: 'none' }} onClick={() => setUpdatePassword(true)}>{translation('userAccount.updatePassword')}</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Col>
                        </Col>

                        <Col md={12} xl={6}>
                            <Col md={11} xxl={10}>
                                <h5 className="mt-3 mb-3"><b>{translation('userAccount.companyLabel')}</b></h5>
                                <Form.Group className="mb-2">
                                    <Form.Label className="text-darker-grey">{translation('userAccount.company.name')}:</Form.Label>
                                    <Form.Control type="text" placeholder={translation('userAccount.company.name')} defaultValue={company && company.name ? company.name : ""} {...register("socialReason", { required: true })} />
                                    {errors.socialReason ? (<div className="w-100"> <Error>{errors.socialReason?.message}</Error> </div>) : ""}
                                </Form.Group>

                                <Form.Group className="mb-2">
                                    <Form.Label className="text-darker-grey">{translation('userAccount.company.fantasy')}:</Form.Label>
                                    <Form.Control type="text" placeholder={translation('userAccount.company.fantasy')} defaultValue={company && company.fantasy ? company.fantasy : ""} {...register("fantasyName", { required: true })} />
                                    {errors.fantasyName ? (<div className="w-100"> <Error>{errors.fantasyName?.message}</Error> </div>) : ""}
                                </Form.Group>

                                <Controller
                                    name="cnpj"
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue={company && company.cnpj ? formatCnpj(company.cnpj) : ""}
                                    render={({ field }) => (
                                    <ReactInputMask mask="99.999.999/9999-99" 
                                        value={field.value}
                                        onChange={field.onChange}
                                    >
                                        {(inputProps: any) => (
                                            <Form.Group className="mb-2">
                                                <Form.Label className="text-darker-grey">{translation('userAccount.company.cnpj')}:</Form.Label>
                                                <Form.Control type="text" {...inputProps} placeholder={translation('userAccount.company.cnpj')} {...register("cnpj", { required: true })} />
                                                {errors.cnpj ? (<div className="w-100"> <Error>{errors.cnpj?.message}</Error> </div>) : ""}
                                            </Form.Group>
                                        )}
                                    </ReactInputMask>
                                    )}
                                />

                                <h5 className="mt-4 mb-3"><b>{translation('userAccount.company.address')}</b></h5>
                                <Form.Group className="mb-2">
                                    <Row className="mb-2">
                                        <Col md={3}>
                                            <Controller
                                                name="cep"
                                                control={control}
                                                rules={{ required: true }}
                                                defaultValue={company && company.address && company.address.cep ? company.address.cep : ""}
                                                render={({ field }) => (
                                                <ReactInputMask mask="99999-999" 
                                                    value={field.value}
                                                    onChange={field.onChange}
                                                >
                                                    {(inputProps: any) => (
                                                        <Form.Group className="mb-2">
                                                            <Form.Label className="text-darker-grey">{translation('userAccount.company.cep')}:</Form.Label>
                                                            <Form.Control type="text" {...inputProps} placeholder={translation('userAccount.company.cep')} {...register("cep", { required: true })} />
                                                            {errors.cep ? (<div className="w-100"> <Error>{errors.cep?.message}</Error> </div>) : ""}
                                                        </Form.Group>
                                                    )}
                                                </ReactInputMask>
                                                )}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Label className="text-darker-grey">{translation('userAccount.company.place')}:</Form.Label>
                                            <Form.Control type="text" placeholder={translation('userAccount.company.place')} defaultValue={company && company.address && company.address.public_space ? company.address.public_space : ""} {...register("address", { required: true })} />
                                            {errors.address ? (<div className="w-100"> <Error>{errors.address?.message}</Error> </div>) : ""}
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col md={3}>
                                            <Form.Label className="text-darker-grey">{translation('userAccount.company.number')}:</Form.Label>
                                            <Form.Control type="text" placeholder="Número" defaultValue={company && company.address && company.address.number ? company.address.number : ""} {...register("number", { required: true })} />
                                            {errors.number ? (<div className="w-100"> <Error>{errors.number?.message}</Error> </div>) : ""}
                                        </Col>
                                        <Col>
                                            <Form.Label className="text-darker-grey">{translation('userAccount.company.district')}:</Form.Label>
                                            <Form.Control type="text" placeholder="Bairro" defaultValue={company && company.address && company.address.district ? company.address.district : ""} {...register("district", { required: true })} />
                                            {errors.district ? (<div className="w-100"> <Error>{errors.district?.message}</Error> </div>) : ""}
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col>
                                            <Form.Label className="text-darker-grey">{translation('userAccount.company.city')}:</Form.Label>
                                            <Form.Control type="text" placeholder="Cidade" defaultValue={company && company.address && company.address.city ? company.address.city : ""} {...register("city", { required: true })} />
                                            {errors.city ? (<div className="w-100"> <Error>{errors.city?.message}</Error> </div>) : ""}
                                        </Col>
                                        <Col md={3}>
                                            <Form.Label className="text-darker-grey">{translation('userAccount.company.state')}:</Form.Label>
                                            <Form.Control type="text" placeholder="Estado" defaultValue={company && company.address && company.address.state ? company.address.state : ""} {...register("state", { required: true })} />
                                            {errors.state ? (<div className="w-100"> <Error>{errors.state?.message}</Error> </div>) : ""}
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                        </Col>
                        <Col md={12} className="mt-4 mb-4">
                            <Button className="mb-1" type="submit" disabled={loadingSubmit}>{translation('manager.saveChanges')}</Button>
                            {
                                loadingSubmit &&
                                <Spinner animation="border" variant="primary" style={{ width: '1.2rem', height: '1.2rem', borderWidth: '0.15em', borderRightColor: 'transparent', marginLeft: '8px'}} />
                            }
                        </Col>
                    </Row>
                </Form>
            </ContentBody>
            {/* modal update email */}
            <Modal
                headerTitle={translation('userAccount.updateEmail')} 
                submitButtonText={translation('save')} 
                show={updateEmail} 
                onHide={() => setUpdateEmail(false)} 
                onSubmit={handleSubmitMail(onSubmitEmailUpdate)} 
                variant="form-modal"
                loading={loadingModal}
            >
                <Form>
                    <Form.Group className="mb-2">
                        <Form.Label className="text-darker-grey">{translation('userAccount.currentEmail')}:</Form.Label>
                        <Form.Control type="text" placeholder={translation('userAccount.currentEmail')} defaultValue={user.email} disabled/>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label className="text-darker-grey">{translation('userAccount.newEmail')}:</Form.Label>
                        <Form.Control type="text" placeholder={translation('userAccount.newEmail')} {...registerMail("email", { required: true })} />
                        {errorsMail.email ? (<div className="w-100"> <Error>{errorsMail.email?.message}</Error> </div>) : ""}
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label className="text-darker-grey">{translation('userAccount.confirmNewEmail')}:</Form.Label>
                        <Form.Control type="text" placeholder={translation('userAccount.confirmNewEmail')} {...registerMail("confirmEmail", { required: true })} />
                        {errorsMail.confirmEmail ? (<div className="w-100"> <Error>{errorsMail.confirmEmail?.message}</Error> </div>) : ""}
                    </Form.Group>
                </Form>
            </Modal>

            {/* modal update pssword */}
            <Modal
                headerTitle={translation('userAccount.updatePassword')} 
                submitButtonText={translation('save')} 
                show={updatePassword} 
                onHide={() => setUpdatePassword(false)} 
                onSubmit={handleSubmitPassword(onSubmitPassword)}
                variant="form-modal"
                loading={loadingModal}
                >
                <Form>
                    <Form.Group className="mb-2">
                        <Form.Label className="text-darker-grey">{translation('userAccount.currentPassword')}:</Form.Label>
                        <Form.Control type={showCurrentPassword ? "text" : "password"} placeholder={translation('userAccount.currentPassword')} {...registerPassword("currentPassword", { required: true })}/>
                        <span className="eye-password-icon-modal">
                            {
                                showCurrentPassword ? (
                                    <MdOutlineVisibility style={{ width: "22px", height: "22px", color: colors.greyscale.dark_grey }} onClick={() => setShowCurrentPassword(false)} />
                                ) : (
                                    <MdOutlineVisibilityOff style={{ width: "22px", height: "22px", color: colors.greyscale.dark_grey }} onClick={() => setShowCurrentPassword(true)} />
                                )
                            }
                        </span>
                        {errorsPassword.currentPassword ? (<div className="w-100"> <Error>{errorsPassword.currentPassword?.message}</Error> </div>) : ""}
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label className="text-darker-grey">{translation('userAccount.newPassword')}:</Form.Label>
                        <Form.Control type={showPassword ? "text" : "password"} placeholder={translation('userAccount.newPassword')} {...registerPassword("newPassword", { required: true })} />
                        <span className="eye-password-icon-modal">
                            {
                                showPassword ? (
                                    <MdOutlineVisibility style={{ width: "22px", height: "22px", color: colors.greyscale.dark_grey }} onClick={() => setShowPassword(false)} />
                                ) : (
                                    <MdOutlineVisibilityOff style={{ width: "22px", height: "22px", color: colors.greyscale.dark_grey }} onClick={() => setShowPassword(true)} />
                                )
                            }
                        </span>
                        {errorsPassword.newPassword ? (<div className="w-100"> <Error>{errorsPassword.newPassword?.message}</Error> </div>) : ""}
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label className="text-darker-grey">{translation('userAccount.confirmNewPassword')}:</Form.Label>
                        <Form.Control type={showConfirmPassword ? "text" : "password"} placeholder={translation('userAccount.confirmNewPassword')} {...registerPassword("confirmPassword", { required: true })} />
                        <span className="eye-password-icon-modal">
                            {
                                showConfirmPassword ? (
                                    <MdOutlineVisibility style={{ width: "22px", height: "22px", color: colors.greyscale.dark_grey }} onClick={() => setShowConfirmPassword(false)} />
                                ) : (
                                    <MdOutlineVisibilityOff style={{ width: "22px", height: "22px", color: colors.greyscale.dark_grey }} onClick={() => setShowConfirmPassword(true)} />
                                )
                            }
                        </span>
                        {errorsPassword.confirmPassword ? (<div className="w-100"> <Error>{errorsPassword.confirmPassword?.message}</Error> </div>) : ""}
                    </Form.Group>
                </Form>
            </Modal>
        </Container>
    )
}